import { apiClient } from '@app/api/index';
import {
  MatchesAddScreenP,
  MatchesAddScreenPropsP,
} from '@app/modules/audit/modules/station-audit/screens/matches-add/screen_p';
import { useToast } from '@app/core/notifications';
import { AuditMatch } from '@mi-front/core';
import { useIntl } from 'react-intl';

type Props = Pick<MatchesAddScreenPropsP, 'station' | 'datetime' | 'show' | 'onHide'> & {
  onSuccess?: (match: AuditMatch) => unknown;
};

export const MatchesAddPage = (p: Props) => {
  const { station, datetime, show, onHide, onSuccess } = p;
  const { $t } = useIntl();
  const { notifySuccess, notifyError } = useToast();

  return (
    <MatchesAddScreenP
      station={station}
      datetime={datetime}
      submitFn={async (data) => {
        try {
          const match = await apiClient.audit.createManualMatch(station.id, data);

          notifySuccess(
            $t({
              id: 'audit.matchesAdd.created',
              defaultMessage: 'Match manual creado',
            }),
          );

          onHide();

          onSuccess && onSuccess(match);
        } catch (err: any) {
          notifyError(
            $t({
              id: 'audit.matchesAdd.createError',
              defaultMessage: 'Error al crear la coincidencia',
            }),
          );

          throw err;
        }
      }}
      show={show}
      onHide={onHide}
    />
  );
};
